<template>
<CardLayout @onHrTree="onHrTree">
  <div class="department-layout">
    <el-tabs v-model="tabs_active" @tab-click="handleClick">
      <el-tab-pane label="配置列表" name="list">
        <div style="margin: 5px 0">
          <el-button type="primary" size="mini" icon="el-icon-add" @click="preView()">添加</el-button>
          <el-select v-model="where.config_id" placeholder="请选择公司">
            <el-option
              v-for="item2 in config_list"
              :key="item2.id"
              :label="item2.company_name"
              :value="item2.id">
            </el-option>
          </el-select>
          <el-input
            style="width: 240px"
            placeholder="请输入名称/前台电话/24小时热线/所在地"
            v-model="where.kayWord"
            clearable>
          </el-input>
          <el-button @click="searchList()">搜索</el-button>
        </div>
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            v-if="pageData" :data="pageData.list"
            border
            style="width: 100%" height="65vh">
            <el-table-column
              prop="id"
              label="ID" width="60"></el-table-column>
            <el-table-column
              prop="user_count"
              label="架构人数" width="80"></el-table-column>
            <el-table-column
              prop="name"
              label="名称(区域/部门)"
              width="200">
              <template slot-scope="scope">
                <el-link v-if="scope.row.name" type="primary" @click="preView(scope.row)">{{scope.row.name}}</el-link>
                <el-link v-if="!scope.row.name" type="danger" @click="preView(scope.row)">请命名</el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="qrcode_file"
              label="二维码"
              width="100">
              <template slot-scope="scope">
                <el-popover
                  placement="right"
                  trigger="hover">
                  <template slot="default">
                    <div>
                      <div>
                        <img style="width: 300px;height: 300px" :src="getHost(scope.row.qrcode_file)">
                      </div>
                      <div style="text-align: center;">
                        <el-button type="primary" @click="download(getHost(scope.row.qrcode_file),scope.row.department_name+'.png')">下载二维码</el-button>
                        <el-button type="primary" @click="reQRcode(scope.row,'list')">刷新二维码</el-button>
                      </div>
                    </div>
                  </template>
                  <div slot="reference">
                    <img style="width: 60px;height: 60px" :src="getHost(scope.row.qrcode_file)">
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              prop="department_name"
              label="组织架构"
              width="200">
            </el-table-column>
            <el-table-column
              prop="config_name"
              label="公司"
              width="200">
            </el-table-column>
            <el-table-column
              label="工作时间"
              width="150">
              <template slot-scope="scope">
                <div>上午：{{scope.row.forenoon_start_time}}-{{scope.row.forenoon_end_time}}</div>
                <div>下午：{{scope.row.afternoon_start_time}}-{{scope.row.afternoon_end_time}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="hot_wire_telephone"
              label="24小时热线"
              width="120">
            </el-table-column>
            <el-table-column
              prop="front_desk_phone"
              label="前台电话"
              width="120">
            </el-table-column>
            <el-table-column
              prop="office_address"
              label="所在地址"
              width="200">
            </el-table-column>
            <el-table-column
              prop="update_time"
              label="更新时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="create_user"
              label="添加操作人"
              width="150">
            </el-table-column>
            <el-table-column
              prop="update_user"
              label="更新操作人"
              width="150">
            </el-table-column>
            <el-table-column
              label="	操作"
              width="220">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-view" @click="preView(scope.row)">编辑</el-button>
                <el-button type="danger" size="mini" icon="el-icon-delete" @click="delConfig(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="配置详情" :disabled="true" name="show">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="配置名称" prop="front_desk_phone">
                <el-input class="form-input" v-model="form.name" placeholder="输入名称" autocomplete="off"></el-input>
                <span style="color: #bdbdbd">用于区别同一个组织架构下的区域或者组织架构上体现不出的部门</span>
              </el-form-item>
              <el-form-item label="所属组织" prop="department_name">
                <div>
                  <span v-if="!form.department_name" style="color: #ff0000">点击左侧的组织架构树</span>
                  <span v-if="form.department_name" style="color: #0ec700">{{form.department_name}}</span>
                </div>
                <div>
                  <span style="color: #bdbdbd">请点击左侧自己所在的组织构架</span>
                </div>
              </el-form-item>

              <el-form-item label="公司选项" prop="company_name">
                <el-select v-model="form.config_id" placeholder="请选择">
                  <el-option
                    v-for="item2 in config_list"
                    :key="item2.id"
                    :label="item2.company_name"
                    :value="item2.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工作时间" prop="hot_wire_telephone">
                <el-row>
                  <el-col :span="4">上午:</el-col>
                  <el-col :span="20">
                    <div style="display: flex;flex-direction: row">
                      <el-time-select
                        v-model="form.forenoon_start_time"
                        :picker-options="picker_options"
                        value-format="H:mm"
                        placeholder="开始时间">
                      </el-time-select>
                      -
                      <el-time-select
                        v-model="form.forenoon_end_time"
                        :picker-options="picker_options"
                        value-format="H:mm"
                        placeholder="结束时间">
                      </el-time-select>
                    </div>
                  </el-col>
                </el-row>
                <div style="height: 5px;"></div>
                <el-row>
                  <el-col :span="4">下午:</el-col>
                  <el-col :span="20">
                    <div style="display: flex;flex-direction: row">
                      <el-time-select
                        v-model="form.afternoon_start_time"
                        :picker-options="picker_options"
                        value-format="H:mm"
                        placeholder="开始时间">
                      </el-time-select>
                      -
                      <el-time-select
                        v-model="form.afternoon_end_time"
                        :picker-options="picker_options"
                        value-format="H:mm"
                        placeholder="结束时间">
                      </el-time-select>
                    </div>

                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="24小时热线" prop="hot_wire_telephone">
                <el-input class="form-input" v-model="form.hot_wire_telephone" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="前台电话" prop="front_desk_phone">
                <el-input class="form-input" v-model="form.front_desk_phone" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="办公地址" prop="front_desk_phone">
                <el-input class="form-input" v-model="form.office_address" maxlength="25" placeholder="地址最长25个字" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="地图标记">
                <div>
                  <el-link @click="openMap(form)" :type="(form.latitude&&form.longitude)?'success':'info'">维度：{{form.latitude}} 经度：{{form.longitude}}</el-link>
                  <el-popover
                    placement="right"
                    trigger="hover">
                    <template slot="default">
                      <el-alert
                        v-if="(form.latitude&&form.longitude)"
                        title="房产地址定位"
                        type="success"
                        effect="dark">
                        <div>维度：{{form.latitude}}</div>
                        <div>经度：{{form.longitude}}</div>
                        <div>
                          地址：{{form.loacl_address}}
                          <el-button v-if="!form.loacl_address" @click="getLoaclAddress()" size="mini" type="text">获取地址</el-button>
                        </div>
                      </el-alert>

                      <el-alert
                        v-if="!(form.latitude&&form.longitude)"
                        title="请点击设置！"
                        type="warning"
                        effect="dark">
                      </el-alert>
                    </template>
                    <i @click="openMap(form)" :style="{color:((form.latitude&&form.longitude)?'#42a936':'#FF9900')}" style="font-size: 23px;" slot="reference" class="el-icon-location"></i>
                  </el-popover>
                </div>
                <div>
                  <span style="color: #ff3d00">请点击定位按钮进行定位操作返回GPS位置</span>
                </div>
              </el-form-item>

              <el-form-item label="" prop="company_name">
                <el-button type="primary" @click="submitForm()">保存</el-button>
              </el-form-item>


            </el-col>
            <el-col :span="12">
              <el-form-item label="二维码链接" prop="company_name">
                <div style="display: flex;flex-direction: row;">
                  <el-input class="form-input" readonly :value="form.qrcode_file?getHost(form.qrcode_file):''" placeholder="输入视频全链接" autocomplete="off"></el-input>
                  <el-button v-if="form.qrcode_file" @click="download(getHost(form.qrcode_file),form.department_name+'.png')">下载</el-button>
                </div>
              </el-form-item>
              <el-form-item label="二维码图片" prop="company_name">
                <img
                  v-if="form.qrcode_file"
                  style="width: 200px; height: 200px"
                  :src="getHost(form.qrcode_file)" alt=""/>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
  <SelectMap ref="SelectMap" />
</CardLayout>
</template>

<script>
import CardLayout from "./components/CardLayout";
import SelectDepartmentCascader from "./components/SelectDepartmentCascader";
import xhHelp from "./xhHelp";
import SelectMap from "../../Common/SelectMap";
export default {
  name: "DepartmentConfig",
  components: {SelectMap, SelectDepartmentCascader, CardLayout},
  data(){
    return {
      department_id:"",
      form:{
        name:"",
        department_id:"",
        department_name:"",
        hot_wire_telephone:"",
        front_desk_phone:"",
        office_address:"",
        latitude:"",
        longitude:"",
        loacl_address:"",
        qrcode_file:"",
        config_id:"",
        forenoon_start_time:"8:00",
        forenoon_end_time:"12:00",
        afternoon_start_time:"14:00",
        afternoon_end_time:"18:00"
      },
      picker_options:{format:'H:mm',start: '00:00',step:'00:05',end: '23:59'},
      config_list:[],
      tabs_active:"list",
      where:{
        department_id:"",
        config_id:"",
        kayWord:"",
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 0,
      },
      loading:false,
    }
  },
  created() {
    this.getConfigList()
    this.getDepartmentConfigList();
  },
  methods:{
    handleClick(tab){
      const that=this;
      if(that.tabs_active==='list'){
        // that.getDepartmentConfigList();
      }
    },
    openMap(item){
      const that=this;
      that.$refs.SelectMap.show({
        longitude:item.longitude,
        latitude:item.latitude,
        callback(ret){
          if(!that.form.office_address) that.form.office_address=ret.formattedAddress;
          that.loacl_address=ret.formattedAddress;
          that.form.longitude=ret.lng;
          that.form.latitude=ret.lat;
          // console.log(ret);
        }
      })
    },
    getHost(url){
      return xhHelp.hostUrl(url)
    },
    getData(){
      const that=this;
      xhHelp.get('DepartmentConfig/getDepartmentConfig',{
        department_id:that.form.department_id,
      },ret=>{
        if(ret.code){
          ret.data&&(that.form=ret.data)
        }else {
          that.$message.error(ret.msg||'数据加载异常')
        }
      })
    },
    submitForm(){
      const that=this;
      if(!that.form.department_id){
        that.$message.error('选择右侧架构树对应的项目部门')
      }
      if(!that.form.config_id){
        that.$message.error('请选择公司')
      }
      xhHelp.post('DepartmentConfig/updateDepartmentConfig',that.form,ret=>{
        if(ret.code){
          that.$message.success('保存成功')
          // that.getData()
          that.getDepartmentConfigList();
        }else {
          that.$message.error(ret.msg||'操作异常')
        }
      })
    },
    delConfig(item){
      const that=this;
      if(item.user_count){
        that.$message.error(`该绑定还有 ${item.user_count} 人，请清退人员才可以删除！`)
        return false;
      }
      xhHelp.post('DepartmentConfig/delDepartmentConfig',{id:item.id},ret=>{
        if(ret.code){
          that.$message.success("删除成功");
          that.getDepartmentConfigList();
        }else {
          that.$message.error(ret.msg||'操作异常')
        }
      })
    },
    reQRcode(form,type=""){
      const that=this;
      if(!form.department_id){
        that.$message.error('选择右侧架构树对应的项目部门')
      }
      if(!form.config_id){
        that.$message.error('请选择公司')
      }
      xhHelp.post('DepartmentConfig/updateDepartmentConfig',form,ret=>{
        if(ret.code){
          that.$message.success('刷新成功')
          type==='info'&&that.getData()
          type==='list'&&that.getDepartmentConfigList()
        }else {
          that.$message.error(ret.msg||'刷新失败')
        }
      })
    },
    getConfigList(){
      const that=this;
      xhHelp.get('DepartmentConfig/getConfigList',{},ret=>{
        if(ret.code){
          that.config_list=ret.data;
        }else {
          that.$message.error(ret.msg||'操作异常')
        }
      })
    },
    getDepartmentConfigList(){
      const that=this;
      xhHelp.get('DepartmentConfig/getDepartmentConfigList',{
        ...that.where,
        page:that.pageData.page,
        size:that.pageData.pageSize
      },ret=>{
        if(ret.code){
          that.pageData=ret.data;
        }else {
          that.$message.error(ret.msg||'操作异常')
        }
      })
    },
    searchList(){
      const that=this;
      that.pageData.page=1;
      that.getDepartmentConfigList();
    },
    pageChange(i) {
      this.pageData.page = i
      this.getDepartmentConfigList()
    },
    onHrTree(e){
      const that=this;
      if(that.tabs_active==="show"){
        that.department_id=e.id;
        that.form.department_id=e.id;
      }else {
        that.where.department_id=e.id;
        that.pageData.page=1;
        that.getDepartmentConfigList();
      }
      that.form.department_name=e.ancestor_name;
    },
    getLoaclAddress(){
      const that=this;
      ERP.getRequest({url:"admin/HouseCode/getLocationPostion",data:{
          lat:that.form.latitude,
          lng:that.form.longitude
        }},ret=>{
        if(ret.code){
          that.form.loacl_address=(ret.data.regeocode||{}).formatted_address||'';
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    preView(item=null){
      const that=this;
      if(!item){
        item={
          name:"",
          department_id:"",
          department_name:"",
          hot_wire_telephone:"",
          front_desk_phone:"",
          office_address:"",
          latitude:"",
          longitude:"",
          loacl_address:"",
          qrcode_file:"",
          config_id:"",
          forenoon_start_time:"8:00",
          forenoon_end_time:"12:00",
          afternoon_start_time:"14:00",
          afternoon_end_time:"18:00"
        }
      }
      that.form=item;
      that.tabs_active="show"
    },
    download(url = '', fileName = '未知文件') {
      if(!url){
        this.$message.error("无文件下载")
        return false
      }
      const a = document.createElement('a');
      a.style.display = 'none';
      a.setAttribute('target', '_blank');
      /*
       * download的属性是HTML5新增的属性
       * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
       * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
       * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
       */
      fileName && a.setAttribute('download', fileName);
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";

.department-layout{
  //width: 500px;
  margin-left: 20px;
  margin-top: 20px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/DepartmentConfig.vue